const store = require("../store.js");
const actions = require("../actions/FileSelectionActions.js");

const dispatch = store.dispatch;

const creators = {
    Add(file) {
        dispatch({
            type: actions.Add,
            File: file
        });
    },
    Remove(file) {
        dispatch({
            type: actions.Remove,
            File: file
        });
    }
};

module.exports = creators;


// WEBPACK FOOTER //
// ./src/actionCreators/FileSelectionActionCreators.js